<template>
    <div>
        <router-view></router-view>
        <!-- App Bottom Menu -->
        <div class="appBottomMenu shadow-header-footer" style="max-width:480px;margin:auto;" v-if="isAuth && currentPage==='home' || currentPage==='transaction.index' || currentPage==='kemitraan' || currentPage==='info.index' || currentPage==='account'">
            <router-link :to="{name:'home'}" class="item" :class="[currentPage.includes('home') ? activeClass : '']">
                <div class="col">
                    <ion-icon name="home"></ion-icon>
                    <strong>Beranda</strong>
                </div>
            </router-link>
            <router-link :to="{name:'transaction.index'}" class="item" :class="[currentPage.includes('transaction') ? activeClass : '']">
                <div class="col">
                    <ion-icon name="clipboard"></ion-icon>
                    <strong>Riwayat</strong>
                </div>
            </router-link>
            <router-link :to="{name:'kemitraan'}" class="item" :class="[currentPage.includes('kemitraan') ? activeClass : '']">
                <div class="col">
                    <ion-icon name="storefront"></ion-icon>
                    <strong>Kemitraan</strong>
                </div>
            </router-link>
            <router-link :to="{name:'info.index'}" class="item" :class="[currentPage.includes('info') ? activeClass : '']">
                <div class="col">
                    <ion-icon name="newspaper"></ion-icon>
                    <strong>Info</strong>
                </div>
            </router-link>
            <router-link :to="{name:'account'}" class="item" :class="[currentPage.includes('account') ? activeClass : '']">
                <div class="col">
                    <ion-icon name="person-circle"></ion-icon>
                    <strong>Akun</strong>
                </div>
            </router-link>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
export default {
    name: 'App',
    data(){
        return {
            activeClass: 'active'
        }
    },
    created() {
        if (this.isAuth) {
            this.getCustomer().then(() => {
                this.getCategoryPrabayar()
                this.getCategoryPascabayar()
                this.loading.app = false
            })
            this.getSetting().then(() => {
                this.loading.app = false
            })
        }

        const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
            const isShown = window.$('.modal').hasClass('show')
            if (isShown) {
                window.$('.modal').modal('hide')
                next(false)
            } else {
                next()
            }
        })
        this.$once('hook:destroyed', () => {
            unregisterRouterGuard()
        })
    },
    computed:{
        ...mapState(['customer','token','loading','device','VUE_ENV']),
        ...mapMutations(['SET_DEVICE']),
        ...mapGetters(['isAuth']),
        currentPage(){
            return this.$route.name;
        }
    },
    mounted() {
        if(navigator.userAgent.indexOf(this.VUE_ENV.VUE_APP_PACKAGENAME_APK) >= 0){
            this.$store.commit('SET_DEVICE', 'APK')
        }else{
            this.$store.commit('SET_DEVICE', 'WEB')
        }
    },
    methods: {
        ...mapActions(['getCustomer','getSetting','getCategoryPrabayar','getCategoryPascabayar'])
    },
}
</script>